import React from 'react'
import Header from '../components/Common/Header'
import MainComponent from '../components/LandingPage/MainComponent'

const HomePage = () => {
  return (
    <div>
      <Header/>
      <MainComponent/>
    </div>
  )
}

export default HomePage;